module.exports = __webpack_public_path__ + "static/Raleway-Regular-9942588a6c84f959132556d99e83ded6.ttf";